// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"22f8fa03","508":"22f8fa03","551":"5643f081","877":"6951da9a"}[chunkId] + ".chunk.css";
};